/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4c97aebee90c0dd83835b1eca60cb48ae671ab16";
